import { phoneValid, zipValid } from './contactFields.js';
import { newClientFieldRequired } from './newClientForm.js';
import type { SaveBlockItem } from '../components/SaveBlockDialog.js';

/** A New Client window field as the check needs it (subheads start a section). */
export type NewClientCheckField = {
  key: string;
  label: string;
  type: string;
  mask?: 'phone' | 'zip';
};

/**
 * ehr#760: what stops the New Client window's Save, in the client chart's "This record was not
 * saved" terms. Required: First name, Last name, for a client (ehr#734 / ehr#757) Mobile phone and
 * Primary email, and (ehr#758) the "Please specify" box when the referral source is Other. Format:
 * a phone that is not 10 digits, an email or a ZIP that is not complete. `sec` is the key of the
 * group the field sits under (Name, Phone & email, Address), the label is shown without its "*".
 */
/** The pop-up group of the Referral Source write-in (it sits above the field list). */
export const NEW_CLIENT_REFERRAL_SEC = 'referral';

export function newClientProblems(
  fields: readonly NewClientCheckField[],
  values: Record<string, string | undefined>,
  category: string,
  emailOk: (v: string) => boolean,
  referralOtherMissing = false,
): { missing: SaveBlockItem[]; bad: SaveBlockItem[] } {
  const missing: SaveBlockItem[] = [];
  const bad: SaveBlockItem[] = [];
  // Listed first: the Referral Source box is at the top of the window.
  if (referralOtherMissing)
    missing.push({
      sec: NEW_CLIENT_REFERRAL_SEC,
      field: 'referralSourceOther',
      label: 'Referral source (please specify)',
    });
  let sec = '';
  for (const f of fields) {
    if (f.type === 'subhead') {
      sec = f.key;
      continue;
    }
    const v = values[f.key] ?? '';
    const item = { sec, field: f.key, label: f.label.replace(/\s*\*$/, '') };
    const required = newClientFieldRequired(f.key, category);
    if (required && !v.trim()) missing.push(item);
    else if (
      (f.type === 'tel' && !phoneValid(v)) ||
      (f.type === 'email' && !emailOk(v)) ||
      (f.mask === 'zip' && !zipValid(v))
    )
      bad.push(item);
  }
  return { missing, bad };
}
